import * as React from "react";
import { Language, LocalizeContextProps, Translate } from "react-localize-redux";
import { Link } from "react-router-dom";
import Jumbotron from "./Jumbotron";
import Navbar from "./Navbar";
// import './NotFound.scss';

interface IProps extends LocalizeContextProps {
  language: Language;
  languageChanged: any;
}

class NotFound extends React.Component<IProps, {}> {
  public render() {
    return (
      <div>
        <Navbar current={1} language={this.props.language} languageChanged={this.props.languageChanged} />
        <Jumbotron />
        <div className="container">
          <p>
            <Translate id="URLNotFound" />
          </p>
          <p>
            <Link to="/">
              <Translate id="SOP" />
            </Link>
          </p>
        </div>
      </div>
    );
  }
}

export default NotFound;
